<div class="row">
  <div class="col-12">
    <form id="fileForm" autocomplete="off" [formGroup]="fileForm" #formElement>

      <div class="image-wrapper position-relative">
        <img [src]="getSanitizedImageSrc(file)" class="main-image" alt="Arquivo selecionado" />
      
        <button *ngIf="index > 0"
          class="nav-arrow left-arrow"
          (click)="navegarAnterior()"
          nz-button
          nzType="default"
          nzShape="circle"
          [nzSize]="'large'">
          ←
        </button>
        <button *ngIf="index < lista.length - 1"
          class="nav-arrow right-arrow"
          (click)="navegarProximo()"
          nz-button
          nzType="default"
          nzShape="circle"
          [nzSize]="'large'">
          →
        </button>
      </div>

      <ng-container>
        <div class="image-description mt-2">
          <input nz-input id="descricao" [maxLength]="50" formControlName="descricao" 
          nzSize="large" placeholder="Descrição">
        </div>
      </ng-container>

      <div class="row d-flex justify-content-end mt-4">
        <div class="col-2 pe-1" *ngIf="!somenteLeitura">
          <button nz-button nzType="primary" type="button" nzSize="large"
            class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6" (click)="editarDetalhes()"
            [ngClass]="'btn-primary-color'">
            Salvar
            <span class="fs-4 ms-2" [ngClass]="'gg--check-o'"></span>
          </button>
        </div>
        <div class="col-2">
          <button nz-button nzType="default" type="button" nzSize="large"
            class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6" (click)="fecharModal()">
            Fechar
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
